import { atom } from 'recoil'

export default atom({
    key: 'pickableObject',
    default: [],
})
